import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { LogOut, Menu, X, BarChart3 } from 'lucide-react';

interface NavigationProps {
  isAuthenticated: boolean;
  onLogout?: () => void;
}

export const Navigation: React.FC<NavigationProps> = ({ isAuthenticated, onLogout }) => {
  const [isOpen, setIsOpen] = React.useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    onLogout?.();
    navigate('/login');
  };

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav className="bg-gray-950 border-b border-gray-800">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <BarChart3 className="w-6 h-6 text-blue-500" />
            <span className="text-lg font-bold text-white">Atlas OSINT Brasil</span>
          </Link>

          {/* Desktop Menu */}
          {isAuthenticated && (
            <div className="hidden md:flex items-center gap-8">
              <Link
                to="/dashboard"
                className={`text-sm font-medium transition-colors ${
                  isActive('/dashboard')
                    ? 'text-blue-500'
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                Dashboard
              </Link>
              <Link
                to="/investigacoes"
                className={`text-sm font-medium transition-colors ${
                  isActive('/investigacoes')
                    ? 'text-blue-500'
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                Investigações
              </Link>
              <Link
                to="/fontes"
                className={`text-sm font-medium transition-colors ${
                  isActive('/fontes')
                    ? 'text-blue-500'
                    : 'text-gray-300 hover:text-white'
                }`}
              >
                Fontes
              </Link>
              <button
                onClick={handleLogout}
                className="flex items-center gap-2 text-gray-300 hover:text-white transition-colors"
              >
                <LogOut className="w-4 h-4" />
                Sair
              </button>
            </div>
          )}

          {/* Mobile Menu Button */}
          {isAuthenticated && (
            <button
              onClick={() => setIsOpen(!isOpen)}
              className="md:hidden text-gray-300 hover:text-white"
            >
              {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          )}
        </div>

        {/* Mobile Menu */}
        {isOpen && isAuthenticated && (
          <div className="md:hidden pb-4 border-t border-gray-800">
            <Link
              to="/dashboard"
              className="block py-2 text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Dashboard
            </Link>
            <Link
              to="/investigacoes"
              className="block py-2 text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Investigações
            </Link>
            <Link
              to="/fontes"
              className="block py-2 text-gray-300 hover:text-white"
              onClick={() => setIsOpen(false)}
            >
              Fontes
            </Link>
            <button
              onClick={() => {
                handleLogout();
                setIsOpen(false);
              }}
              className="block w-full text-left py-2 text-gray-300 hover:text-white"
            >
              Sair
            </button>
          </div>
        )}
      </div>
    </nav>
  );
};
